// Values match the global FormType where they overlap, but newsletter forms are outside it.
export var CommunicationPreferenceFormType;
(function (CommunicationPreferenceFormType) {
    CommunicationPreferenceFormType["DonationForm"] = "DonationForm";
    CommunicationPreferenceFormType["Ticketing"] = "Ticketing";
    CommunicationPreferenceFormType["NewsletterForm"] = "NewsletterForm";
})(CommunicationPreferenceFormType || (CommunicationPreferenceFormType = {}));
export const COMMUNICATION_PREFERENCE_QUESTION_TITLE_MAX_LENGTH = 255;
export var CommunicationPreferenceSource;
(function (CommunicationPreferenceSource) {
    CommunicationPreferenceSource["FormSubmission"] = "formSubmission";
    CommunicationPreferenceSource["ManualEntry"] = "manualEntry";
    CommunicationPreferenceSource["Import"] = "import";
    CommunicationPreferenceSource["Migration"] = "migration";
    CommunicationPreferenceSource["PreferencePage"] = "preferencePage";
})(CommunicationPreferenceSource || (CommunicationPreferenceSource = {}));
// Whether a question was put to the contact about this list, and where the consent rests when none was.
export var CommunicationPreferenceBasis;
(function (CommunicationPreferenceBasis) {
    // An affirmative act covering this list: a ticked box, or a sign-up form submitted with no box to tick.
    CommunicationPreferenceBasis["Explicit"] = "explicit";
    CommunicationPreferenceBasis["Passive"] = "passive";
    CommunicationPreferenceBasis["Derived"] = "derived";
    // No box shown, and the act it rests on was not about receiving communications.
    CommunicationPreferenceBasis["Implied"] = "implied";
})(CommunicationPreferenceBasis || (CommunicationPreferenceBasis = {}));
